const muiTypography = () => {
  return {
    MuiTypography: {
      defaultProps: {
        component: 'p',
      },
    },
  };
};

export default muiTypography;
